/*
 * Normalise a backend base URL: trim trailing slashes, drop a trailing `/v1`
 * (if someone supplied one), then re-append `/v1`. Idempotent — supplying the
 * host alone OR the host with `/v1` already yields the same result, so ops
 * can't accidentally double up the version segment.
 *
 *   undefined / empty                  → /v1                       (dev proxy)
 *   https://api.example.com            → https://api.example.com/v1
 *   https://api.example.com/v1         → https://api.example.com/v1
 *   https://api.example.com/v1/        → https://api.example.com/v1
 */
const API_VERSION_PATH = 'v1';

export function buildApiBase(raw: string | undefined | null): string {
  const trimmed = raw?.trim() ?? '';
  const stripped = trimmed.replace(/\/+$/, '').replace(/\/v1$/, '');
  return stripped ? `${stripped}/${API_VERSION_PATH}` : `/${API_VERSION_PATH}`;
}
